export default __webpack_public_path__ + "static/USAAdventistHistory-7b72137888dc331be5b8833726575737.jpg";